import {Breadcrumbs, ErrorPopup, Title} from '@management-ui/core';
import React from 'react';
import routes from '../../../../routes';

const Wrapper = ({title, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}/>
      {children}
      <ErrorPopup errors={['school']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Schools', link: routes.schools.index}
];

export default Wrapper;
